import React from "react";
import HelpCardContact, { Props as HelpCardContactProps } from "./HelpCardContact";
import HelpCardCta, { Props as HelpCardCtaProps } from "./HelpCardCta";
import HelpCardIRContact, { HelpCardIRContactProps } from "./HelpCardIRContact";
import HelpCardPressReleaseSignup, {
  HelpCardPressReleaseSignupProps
} from "./HelpCardPressReleaseSignup";
import HelpCardReviewWithRating, {
  Props as HelpCardReviewWithRatingProps
} from "./HelpCardReviewWithRating";
import HelpCardText, { HelpCardTextProps } from "./HelpCardText";
import HelpCardWithRating, {
  Props as HelpCardWithRatingProps
} from "./HelpCardWithRating";

export enum HelpCardColorTheme {
  Default = "variant-1",
  Variant2 = "variant-2",
  Variant3 = "variant-3",
  Variant4 = "variant-4",
  Variant5 = "variant-5"
}

const HelpCardColorThemes = {
  [HelpCardColorTheme.Default]: {
    name: "card-theme-variant-1",
    backgroundColor: "bg-brand-primary-20",
    borderColor: "border-brand-primary-10",
    buttonColor: "primary-light",
    textColor: "text-brand-senary-100",
    hrColor: "bg-brand-senary-100",
    bulletPointBackgroundColor: "bg-brand-secondary-90",
    starButtonBackgroundColor: "bg-brand-primary-70",
    ratingCircleBackgroundColor: "bg-brand-primary-95",
    ratingCircleTextColor: "text-brand-primary-20",
    totalReviewsTextColor: "text-brand-primary-95"
  },
  [HelpCardColorTheme.Variant2]: {
    name: "card-theme-variant-2",
    backgroundColor: "bg-brand-primary-70",
    textColor: "text-brand-senary-100",
    borderColor: "border-brand-primary-50",
    buttonColor: "primary",
    hrColor: "bg-brand-senary-100",
    starButtonBackgroundColor: "bg-card-button-bg-variant-2"
  },
  [HelpCardColorTheme.Variant3]: {
    name: "card-theme-variant-3",
    backgroundColor: "bg-brand-secondary-50",
    borderColor: "border-brand-secondary-40",
    textColor: "text-brand-senary-100",
    hrColor: "bg-brand-senary-100"
  },
  [HelpCardColorTheme.Variant4]: {
    name: "card-theme-variant-4",
    backgroundColor: "bg-brand-tertiary-70",
    borderColor: "border-brand-tertiary-50",
    buttonColor: "primary",
    textColor: "text-brand-senary-100",
    hrColor: "bg-brand-senary-100",
    starButtonBackgroundColor: "bg-brand-primary-20"
  },
  [HelpCardColorTheme.Variant5]: {
    name: "card-theme-neutral",
    backgroundColor: "bg-neutral-100",
    borderColor: "border-brand-primary-95",
    buttonColor: "primary-light",
    textColor: "text-brand-primary-20",
    hrColor: "bg-brand-primary-20",
    bulletPointBackgroundColor: "bg-brand-secondary-90",
    starButtonBackgroundColor: "bg-brand-primary-70",
    ratingCircleBackgroundColor: "bg-brand-primary-95",
    ratingCircleTextColor: "text-brand-primary-20",
    totalReviewsTextColor: "text-brand-primary-95"
  }
};

export const getHelpCardColorTheme = (theme: HelpCardColorTheme) => ({
  ...HelpCardColorThemes[HelpCardColorTheme.Default],
  ...HelpCardColorThemes[theme]
});

export enum HelpCardType {
  Contact = "cardContact",
  Cta = "cardCta",
  IRContact = "cardIRContact",
  PressReleaseSignup = "cardPressSignup",
  Rating = "cardRating",
  ReviewWithRating = "cardReviewWithRating",
  Text = "cardText"
}

export type HelpCardProps =
  | HelpCardTextProps
  | HelpCardContactProps
  | HelpCardCtaProps
  | HelpCardIRContactProps
  | HelpCardPressReleaseSignupProps
  | HelpCardWithRatingProps
  | HelpCardReviewWithRatingProps;

const HelpCard = (props: HelpCardProps) => {
  switch (props._type) {
    case HelpCardType.Rating:
      return <HelpCardWithRating {...props} />;
    case HelpCardType.ReviewWithRating:
      return <HelpCardReviewWithRating {...props} />;
    case HelpCardType.Contact:
      return <HelpCardContact {...props} />;
    case HelpCardType.Cta:
      return <HelpCardCta {...props} />;
    case HelpCardType.IRContact:
      return <HelpCardIRContact {...props} />;
    case HelpCardType.PressReleaseSignup:
      return <HelpCardPressReleaseSignup {...props} />;
    case HelpCardType.Text:
    default:
      return <HelpCardText {...props} />;
  }
};

export default HelpCard;
